<template>
  <div id="app" @click="closeMenus">
    <nav class="navbar" :class="{scrolled: isScrolled}">
      <div class="container nav-in">
        <div class="brand" @click="setView('home')">
          <svg class="brand-logo-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
            <path d="M50 2 L93 26.5 L93 73.5 L50 98 L7 73.5 L7 26.5 Z" fill="#00A878" stroke="none"/>
            <path d="M12 29 L50 92 L88 29 L72 29 L50 68 L28 29 Z" fill="#FFF"/>
          </svg>
          
          <span>VERDICT</span>
        </div>
        
        <div class="nav-links pc-only">
          <div class="link-item" @click="setView('home')">{{ txt.menu.markets }}</div>
          <div class="link-item has-drop">
            {{ txt.menu.eco }} ▾
            <div class="dropdown mega-menu">
              <div class="drop-row" @click="setView('ecosystem')"><div class="d-icon">⚡</div><div><div class="d-title">{{ txt.sub.token_t }}</div><div class="d-desc">{{ txt.sub.token_d }}</div></div></div>
              <div class="drop-row" @click="setView('security')"><div class="d-icon">🗳️</div><div><div class="d-title">{{ txt.sub.sec_t }}</div><div class="d-desc">{{ txt.sub.sec_d }}</div></div></div>
            </div>
          </div>
          <div class="link-item" @click="setView('nodes')">{{ txt.menu.nodes }}</div>
          <div class="link-item has-drop">
            {{ txt.menu.resources }} ▾
            <div class="dropdown mega-menu">
              <div class="drop-row" @click="setView('whitepaper')"><div class="d-icon">📜</div><div><div class="d-title">{{ txt.sub.wp_t }}</div><div class="d-desc">{{ txt.sub.wp_d }}</div></div></div>
            </div>
          </div>
        </div>
        <div class="nav-right">
          <div class="lang-wrap pc-only" @click.stop="toggleLang"><span class="lang-btn">🌐 {{ langNames[currentLang] }} ▾</span><div class="lang-drop" v-show="isLangOpen"><div class="l-item" @click.stop="switchLang('en')">English</div><div class="l-item" @click.stop="switchLang('zh')">简体中文</div><div class="l-item" @click.stop="switchLang('tw')">繁體中文</div></div></div>
          <button v-if="!address" class="connect-btn pc-only" @click.stop="openWalletModal">{{ txt.wallet.connect }}</button>
          <div v-else class="addr-badge pc-only" @click="disconnect"><span class="dot"></span> {{ shortAddr }}</div>
          <div class="mobile-controls mobile-only"><button v-if="!address" class="m-header-btn" @click.stop="openWalletModal">Connect</button><div class="hamburger" @click.stop="mobileMenuOpen = !mobileMenuOpen"><div class="bar"></div><div class="bar"></div><div class="bar"></div></div></div>
        </div>
      </div>
    </nav>

    <div class="mobile-menu-mask" v-if="mobileMenuOpen" @click="mobileMenuOpen = false"></div>
    <div class="mobile-drawer" :class="{open: mobileMenuOpen}">
      <div class="drawer-header"><span class="brand">Menu</span><div class="lang-mobile"><span :class="{active: currentLang==='en'}" @click="switchLang('en')">EN</span><span :class="{active: currentLang==='zh'}" @click="switchLang('zh')">中</span><span :class="{active: currentLang==='tw'}" @click="switchLang('tw')">繁</span></div></div>
      <div class="drawer-list">
        <div class="d-item" @click="setView('home')">🏠 {{ txt.menu.markets }}</div>
        <div class="d-group-title">{{ txt.menu.eco }}</div>
        <div class="d-sub-item" @click="setView('ecosystem')">⚡ {{ txt.sub.token_t }}</div>
        <div class="d-sub-item" @click="setView('security')">🗳️ {{ txt.sub.sec_t }}</div>
        <div class="d-item" @click="setView('nodes')">🚀 {{ txt.menu.nodes }}</div>
        <div class="d-group-title">{{ txt.menu.resources }}</div>
        <div class="d-sub-item" @click="setView('whitepaper')">📜 {{ txt.sub.wp_t }}</div>
        <div v-if="address" class="m-addr-box">🟢 {{ address }}<div class="m-disconnect" @click="disconnect">Disconnect</div></div>
      </div>
    </div>

    <div class="main-body">
      <Home v-if="currentView === 'home'" :lang="currentLang" @open-market="openMarket" @switch-view="setView" @purchase-node="handleNodePurchase" />
      <Whitepaper v-if="currentView === 'whitepaper'" :lang="currentLang" />
      <Ecosystem v-if="currentView === 'ecosystem'" :lang="currentLang" />
      <Security v-if="currentView === 'security'" :lang="currentLang" />
      <Nodes v-if="currentView === 'nodes'" :lang="currentLang" :address="address" @purchase-node="handleNodePurchase" @connect-wallet="connectWallet" />
      <LegalDoc v-if="currentView === 'terms'" type="terms" :lang="currentLang" />
      <LegalDoc v-if="currentView === 'privacy'" type="privacy" :lang="currentLang" />
      <HelpCenter v-if="currentView === 'help'" :lang="currentLang" />
      <div v-if="currentView === 'market'" class="market-page container"><div class="back-btn" @click="setView('home')">← {{ txt.menu.markets }}</div><TradingCard :activeMarket="activeMarket" :lang="currentLang" /></div>
    </div>

    <footer class="footer-simple">
      <div class="container footer-content">
        <div class="fc-left">{{ txt.footer.rights }}</div>
        <div class="fc-right">
          <a href="#" @click.prevent="setView('terms')">{{ txt.footer.terms }}</a>
          <a href="#" @click.prevent="setView('privacy')">{{ txt.footer.privacy }}</a>
          <a href="#" @click.prevent="setView('help')">{{ txt.footer.help }}</a>
          <span class="divider">|</span>
          <a href="#" class="social-icon">𝕏</a>
          <a href="#" class="social-icon">TG</a>
        </div>
      </div>
    </footer>

    <div class="modal-mask" v-if="showWalletModal" @click.self="showWalletModal = false">
      <div class="wallet-modal">
        <div class="wm-head"><h3>{{ txt.wallet.connect }}</h3><span class="close" @click="showWalletModal = false">✕</span></div>
        <div class="w-list" v-if="isDAppEnv">
          <div class="w-option detected-active" @click="connectWallet">
            <div class="wo-left"><img src="https://cryptologos.cc/logos/binance-coin-bnb-logo.png?v=029" width="28"><span>Binance Chain Wallet</span></div>
            <div class="wo-right status-ok">Detected</div>
          </div>
          <p class="dapp-hint">DApp Browser Environment Detected.</p>
        </div>
        <div class="w-list mobile-guide" v-else>
          <div class="w-option deep-link-btn" @click="openDeepLink"><div class="wo-left"><span class="btn-icon">🚀</span><span>Open in Wallet App</span></div><div class="wo-right arrow">➔</div></div>
          <div class="w-option copy-link-btn" @click="copyLink"><div class="wo-left"><span class="btn-icon">📋</span><span>Copy URL</span></div><div class="wo-right status-gray">{{ copyText }}</div></div>
          <div class="guide-text">Please open this link in a Decentralized Wallet (e.g. MetaMask, Trust Wallet) to access features.</div>
        </div>
      </div>
    </div>

    <!-- 转账确认对话框 -->
    <div class="modal-mask" v-if="showTransferConfirm" @click.self="cancelTransfer">
      <div class="transfer-confirm-modal">
        <div class="tcm-head">
          <h3>⚠️ 转账安全确认</h3>
          <span class="close" @click="cancelTransfer">✕</span>
        </div>
        <div class="tcm-body">
          <div class="security-warning" v-if="!transferConfirmData.isWhiteListed">
            <div class="warning-icon">⚠️</div>
            <div class="warning-text">
              <strong>安全警告：</strong>此收款地址不在白名单中，可能存在安全风险！
            </div>
          </div>
          
          <div class="transfer-details">
            <div class="detail-row">
              <span class="detail-label">转账金额：</span>
              <span class="detail-value">{{ transferConfirmData.amount }} USDT</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">收款地址：</span>
              <span class="detail-value address-display">{{ transferConfirmData.receiverAddress }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">地址状态：</span>
              <span class="detail-value status-badge" :class="transferConfirmData.isWhiteListed ? 'status-safe' : 'status-warning'">
                {{ transferConfirmData.isWhiteListed ? '✅ 白名单地址' : '⚠️ 非白名单地址' }}
              </span>
            </div>
            <div class="detail-row" v-if="transferConfirmData.memo">
              <span class="detail-label">备注：</span>
              <span class="detail-value">{{ transferConfirmData.memo }}</span>
            </div>
          </div>
          
          <div class="security-tips">
            <p><strong>安全提示：</strong></p>
            <ul>
              <li>请仔细核对收款地址，确保与官方公布地址一致</li>
              <li>转账前确认网络为BSC（币安智能链）</li>
              <li>建议小额测试后再进行大额转账</li>
              <li>如发现地址异常，请立即取消操作</li>
            </ul>
          </div>
        </div>
        <div class="tcm-footer">
          <button class="btn-cancel" @click="cancelTransfer">取消转账</button>
          <button class="btn-confirm" @click="confirmTransfer" :disabled="!transferConfirmData.isWhiteListed">
            {{ transferConfirmData.isWhiteListed ? '确认转账' : '地址不在白名单中' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Home from './components/Home.vue';
import TradingCard from './components/TradingCard.vue';
import Whitepaper from './components/Whitepaper.vue';
import Ecosystem from './components/Ecosystem.vue';
import Security from './components/Security.vue';
import LegalDoc from './components/LegalDoc.vue';
import HelpCenter from './components/HelpCenter.vue';
import Nodes from './components/Nodes.vue';
import DICT from './locales/data.js';
import walletConfig from './config/walletConfig.js';

export default {
  components: { Home, TradingCard, Whitepaper, Ecosystem, Security, LegalDoc, HelpCenter, Nodes },
  data() {
    return {
      isScrolled: false,
      showWalletModal: false,
      mobileMenuOpen: false,
      isLangOpen: false,
      address: '',
      currentView: 'home',
      currentLang: 'en',
      activeMarket: null,
      langNames: { en: 'EN', zh: '简体', tw: '繁體' },
      isDAppEnv: false,
      copyText: 'Click to Copy',
      // 转账确认对话框状态
      showTransferConfirm: false,
      transferConfirmData: {
        amount: 0,
        receiverAddress: '',
        memo: '',
        isWhiteListed: false
      },
      transferConfirmResolve: null
    }
  },
  computed: { shortAddr() { return this.address.slice(0,4)+'...'+this.address.slice(-4) }, txt() { return DICT[this.currentLang].app } },
  mounted() {
    window.addEventListener('scroll', () => { this.isScrolled = window.scrollY > 50 });
    
    // Hash Routing Restore
    const hash = window.location.hash.slice(1);
    if(hash) {
      this.currentView = hash;
    }

    this.checkDAppEnv();
    this.initConfig();
  },
  methods: {
    checkDAppEnv() {
      let attempts = 0;
      const maxAttempts = 20; // 10 seconds total
      const interval = setInterval(() => {
        attempts++;
        if (window.ethereum && window.ethereum.selectedAddress) {
          this.isDAppEnv = true;
          this.address = window.ethereum.selectedAddress; // Auto connect if ready
          clearInterval(interval);
        } else if (window.ethereum) {
          this.isDAppEnv = true;
          clearInterval(interval);
        } else if (attempts >= maxAttempts) {
          this.isDAppEnv = false;
          clearInterval(interval);
        }
      }, 500);
    },
    toggleLang() { this.isLangOpen = !this.isLangOpen; },
    closeMenus() { this.isLangOpen = false; },
    switchLang(lang) { this.currentLang = lang; this.isLangOpen = false; },
    setView(view) {
      this.currentView = view;
      this.mobileMenuOpen = false;
      window.location.hash = view; // Update Hash
      window.scrollTo(0,0);
    },
    openMarket(m) { this.activeMarket = m; this.setView('market'); },
    
    openWalletModal() {
      this.checkDAppEnv();
      this.showWalletModal = true;
    },

    async connectWallet() {
      console.log('App.vue: connectWallet called');
      if(window.ethereum) {
        try {
          console.log('Requesting accounts from ethereum provider');
          const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
          console.log('Accounts received:', accounts);
          if(accounts && accounts.length > 0) {
            this.address = accounts[0];
            this.showWalletModal = false;
            console.log('Wallet connected:', this.address);
          }
        } catch (error) {
          console.error('Wallet connection failed:', error);
        }
      } else {
        console.log('No ethereum provider found, opening wallet modal');
        this.openWalletModal();
      }
    },
    
    openDeepLink() {
      const currentUrl = encodeURIComponent(window.location.href);
      // 币安链钱包的通用 deeplink
      window.location.href = `trust://browser?url=${currentUrl}`;
    },

    copyLink() {
      navigator.clipboard.writeText(window.location.href).then(() => {
        this.copyText = 'Copied!';
        setTimeout(() => this.copyText = 'Click to Copy', 2000);
      });
    },

    disconnect() { if(confirm("Disconnect?")) this.address = ''; },
    
    // 移动端优化的 USDT 转账方法（币安链版本）- 已添加安全验证
    async transferUSDT(amount, toAddress, memo = '') {
      try {
        // 检查是否在移动端环境
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        
        if (!window.ethereum || !window.ethereum.selectedAddress) {
          if (isMobile) {
            // 在移动端，尝试唤起钱包应用
            this.openDeepLink();
            return { success: false, message: '请在钱包应用中完成转账' };
          } else {
            return { success: false, message: '请先连接钱包' };
          }
        }
        
        // 安全验证步骤1：验证并获取安全的收款地址
        let receiverAddress;
        try {
          receiverAddress = walletConfig.getValidatedReceiverAddress(toAddress);
        } catch (validationError) {
          console.error('收款地址验证失败:', validationError);
          return {
            success: false,
            message: `安全验证失败: ${validationError.message}`
          };
        }
        
        // 安全验证步骤2：显示用户确认对话框
        const shouldProceed = await this.showTransferConfirmation({
          amount,
          receiverAddress,
          memo
        });
        
        if (!shouldProceed) {
          console.log('用户取消了转账操作');
          return { success: false, message: '用户取消了转账' };
        }
        
        // 从钱包配置获取USDT合约地址
        const usdtContractAddress = walletConfig.getCurrentUSDTContractAddress();
        
        // 转换金额为最小单位（USDT 有18位小数）
        const amountInWei = (amount * 10**18).toString();
        
        // 构建交易参数
        const transactionParameters = {
          to: usdtContractAddress,
          from: window.ethereum.selectedAddress,
          value: '0x0',
          data: this.encodeTransferData(receiverAddress, amountInWei),
        };
        
        // 发送交易
        const txHash = await window.ethereum.request({
          method: 'eth_sendTransaction',
          params: [transactionParameters],
        });
        
        return {
          success: true,
          message: '转账已提交',
          txId: txHash
        };
        
      } catch (error) {
        console.error('USDT转账错误:', error);
        
        // 移动端特殊处理
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (isMobile && error.message && error.message.includes('ethereum')) {
          // 在移动端，如果以太坊不可用，尝试唤起钱包应用
          const encodedAmount = encodeURIComponent(amount.toString());
          const encodedAddress = encodeURIComponent(walletConfig.getCurrentReceiverAddress());
          const deeplink = `trust://browser?url=${encodeURIComponent(window.location.href)}&action=transfer&amount=${encodedAmount}&token=USDT&to=${encodedAddress}`;
          window.location.href = deeplink;
          return { success: false, message: '正在唤起钱包应用...' };
        }
        
        return { success: false, message: `转账失败: ${error.message || '未知错误'}` };
      }
    },
    
    // 编码转账数据
    encodeTransferData(toAddress, amount) {
      // transfer(address,uint256) 的函数签名
      const functionSignature = '0xa9059cbb';
      
      // 移除地址前缀并填充到32字节
      const paddedAddress = toAddress.replace('0x', '').padStart(64, '0');
      
      // 转换金额为16进制并填充到32字节
      const amountHex = BigInt(amount).toString(16).padStart(64, '0');
      
      return functionSignature + paddedAddress + amountHex;
    },
    
    // 检查是否为移动端
    isMobileDevice() {
      return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    },
    
    // 初始化配置
    async initConfig() {
      try {
        // 尝试从远程获取最新的地址配置
        await walletConfig.fetchRemoteAddresses();
      } catch (error) {
        console.warn('初始化配置失败，使用本地默认配置', error);
      }
    },

    // 显示转账确认对话框（返回Promise）
    showTransferConfirmation(transferData) {
      return new Promise((resolve) => {
        // 设置确认对话框数据
        this.transferConfirmData = {
          amount: transferData.amount,
          receiverAddress: transferData.receiverAddress,
          memo: transferData.memo || '',
          isWhiteListed: walletConfig.isAllowedAddress(transferData.receiverAddress)
        };
        
        // 显示对话框
        this.showTransferConfirm = true;
        
        // 存储resolve函数以便对话框按钮调用
        this.transferConfirmResolve = resolve;
      });
    },
    
    // 确认转账（对话框确认按钮调用）
    confirmTransfer() {
      if (this.transferConfirmResolve) {
        this.transferConfirmResolve(true);
        this.transferConfirmResolve = null;
      }
      this.showTransferConfirm = false;
    },
    
    // 取消转账（对话框取消按钮调用）
    cancelTransfer() {
      if (this.transferConfirmResolve) {
        this.transferConfirmResolve(false);
        this.transferConfirmResolve = null;
      }
      this.showTransferConfirm = false;
    },
    
    // 处理节点购买
    async handleNodePurchase(purchaseData) {
      try {
        const { nodeId, nodeTitle, amount, currency } = purchaseData;
        
        // 显示处理中的提示
        alert(`正在处理 ${nodeTitle} 购买，金额: ${amount} ${currency}...`);
        
        // 调用转账方法
        const result = await this.transferUSDT(amount, null, `购买节点: ${nodeTitle}`);
        
        if (result.success) {
          alert(`购买成功！${nodeTitle} 已激活。交易ID: ${result.txId || '未知'}`);
          
          // 这里可以添加后续逻辑，比如更新用户节点状态等
          console.log(`节点购买成功: ${nodeTitle}, 交易ID: ${result.txId}`);
        } else {
          alert(`购买失败: ${result.message}`);
        }
      } catch (error) {
        console.error('节点购买处理错误:', error);
        alert('处理购买时发生错误，请重试。');
      }
    }
  }
}
</script>

<style>
/* 保持原有样式 */
body { margin: 0; background-color: #000; background-image: radial-gradient(circle at 50% -20%, #0a2e23 0%, #000000 60%); color: #fff; font-family: 'Inter', system-ui, sans-serif; overflow-x: hidden; min-height: 100vh; }
* { box-sizing: border-box; }
.container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }

/* Navbar */
.navbar { position: fixed; top: 0; width: 100%; height: 72px; z-index: 999; border-bottom: 1px solid rgba(255,255,255,0.05); background: rgba(6,7,10,0.9); backdrop-filter: blur(12px); }
.nav-in { height: 100%; display: flex; align-items: center; justify-content: space-between; }

/* Brand - 2. 修改：CSS阴影颜色同步为深绿 */
.brand { display: flex; align-items: center; font-size: 16px; font-weight: 900; cursor: pointer; margin-right: 40px; }
.brand-logo-svg { height: 28px; width: 28px; margin-right: 10px; filter: drop-shadow(0 0 5px rgba(0,168,120,0.5)); }

.nav-links { display: flex; gap: 30px; height: 100%; align-items: center; flex: 1; }
.link-item { color: rgba(255,255,255,0.7); font-size: 14px; cursor: pointer; height: 100%; display: flex; align-items: center; font-weight: 500; position: relative; }
.link-item:hover { color: #fff; }
.has-drop:hover .dropdown { display: block; animation: fadeIn 0.2s; }
.dropdown { display: none; position: absolute; top: 72px; left: -20px; width: 320px; background: #14151a; border: 1px solid rgba(255,255,255,0.1); border-radius: 0 0 12px 12px; padding: 12px; box-shadow: 0 20px 60px rgba(0,0,0,0.6); }
.drop-row { display: flex; gap: 15px; padding: 15px; border-radius: 8px; cursor: pointer; transition: 0.2s; }
.drop-row:hover { background: rgba(255,255,255,0.05); }
.d-icon { font-size: 20px; color: #00D092; }
.d-title { font-weight: 700; color: #fff; font-size: 14px; margin-bottom: 4px; }
.d-desc { font-size: 12px; color: #888; line-height: 1.4; }
.nav-right { display: flex; align-items: center; gap: 20px; }
.lang-wrap { position: relative; height: 100%; display: flex; align-items: center; cursor: pointer; padding: 0 10px; user-select: none; }
.lang-btn { font-size: 13px; font-weight: 600; color: rgba(255,255,255,0.8); }
.lang-drop { position: absolute; top: 60px; right: 0; width: 120px; background: #14151a; border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 5px; box-shadow: 0 10px 40px rgba(0,0,0,0.5); z-index: 2000; }
.l-item { padding: 12px; font-size: 13px; text-align: center; color: #ccc; cursor: pointer; border-radius: 4px; }
.l-item:hover { background: rgba(0,208,146,0.1); color: #00D092; }
.connect-btn { background: #fff; color: #000; border: none; padding: 8px 24px; border-radius: 30px; font-weight: 700; cursor: pointer; transition: 0.3s; font-size: 13px; }
.mobile-controls { display: flex; align-items: center; gap: 15px; }
.m-header-btn { background: #00D092; border: none; padding: 6px 12px; border-radius: 6px; font-weight: bold; font-size: 12px; color: #000; }
.hamburger { flex-direction: column; gap: 5px; cursor: pointer; display: flex; padding: 5px; }
.bar { width: 22px; height: 2px; background: #fff; border-radius: 2px; }
.mobile-menu-mask { position: fixed; inset: 0; background: rgba(0,0,0,0.8); z-index: 1000; backdrop-filter: blur(5px); }
.mobile-drawer { position: fixed; top: 0; right: -300px; width: 280px; height: 100%; background: #101114; z-index: 1001; transition: 0.3s; padding: 20px; border-left: 1px solid #222; overflow-y: auto; }
.mobile-drawer.open { right: 0; }
.drawer-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; }
.lang-mobile span { color: #666; font-size: 14px; font-weight: bold; margin-left: 12px; cursor: pointer; }
.lang-mobile span.active { color: #00D092; }
.d-item { padding: 15px 0; border-bottom: 1px solid rgba(255,255,255,0.05); font-weight: bold; cursor: pointer; }
.d-group-title { margin-top: 25px; margin-bottom: 10px; font-size: 11px; color: #666; text-transform: uppercase; letter-spacing: 1px; }
.d-sub-item { padding: 10px 0; color: #ccc; cursor: pointer; font-size: 14px; }
.m-addr-box { margin-top: 20px; background: #222; padding: 10px; border-radius: 8px; font-size: 12px; color: #00D092; text-align: center; }
.m-disconnect { margin-top: 5px; color: #ff4d4f; cursor: pointer; text-decoration: underline; }
.main-body { padding-top: 72px; min-height: 80vh; }

.mobile-only { display: none !important; }
.pc-only { display: flex !important; }
@media (max-width: 960px) { 
  .pc-only { display: none !important; } 
  .mobile-only { display: flex !important; } 
  .nav-in { padding: 0 15px; }
  .footer-content { flex-direction: column-reverse; gap: 20px; }
  .fc-right { flex-wrap: wrap; justify-content: center; }
}

.footer-simple { background: #050505; border-top: 1px solid #1a1a1a; padding: 30px 0; font-size: 12px; color: #666; }
.footer-content { display: flex; justify-content: space-between; align-items: center; }
.fc-right { display: flex; align-items: center; gap: 20px; }
.fc-right a { color: #888; text-decoration: none; transition: 0.2s; }
.fc-right a:hover { color: #fff; }
.divider { color: #333; }
.social-icon { font-weight: bold; color: #aaa; }

.modal-mask { position: fixed; inset: 0; background: rgba(0,0,0,0.8); z-index: 2000; display: flex; align-items: center; justify-content: center; }
.wallet-modal { background: #1a1b20; width: 360px; border-radius: 16px; padding: 24px; border: 1px solid #333; box-shadow: 0 20px 60px rgba(0,0,0,0.7); }
.wm-head { display: flex; justify-content: space-between; margin-bottom: 20px; font-weight: bold; font-size: 18px; }
.close { cursor: pointer; color: #888; font-size: 20px; }
.w-option { display: flex; justify-content: space-between; align-items: center; background: #25262b; padding: 16px; margin-bottom: 12px; border-radius: 12px; cursor: pointer; border: 1px solid transparent; transition: 0.2s; }
.w-option:hover { border-color: rgba(0,208,146,0.3); background: #2a2b30; }
.wo-left { display: flex; align-items: center; gap: 12px; font-weight: 600; font-size: 15px; }
.wo-right { font-size: 12px; font-weight: bold; padding: 4px 8px; border-radius: 6px; }
.detected-active { border-color: #00D092; background: rgba(0,208,146,0.05); }
.status-ok { color: #00D092; background: rgba(0,208,146,0.1); }
.status-gray { color: #666; background: #333; }
.deep-link-btn { background: #00D092; color: #000; border: none; }
.deep-link-btn:hover { background: #00b881; }
.copy-link-btn { background: #333; color: #fff; }
.btn-icon { font-size: 18px; }
.guide-text { font-size: 12px; color: #888; text-align: center; margin-top: 20px; line-height: 1.5; }
.dapp-hint { text-align: center; color: #00D092; font-size: 12px; margin-top: 10px; }
.market-page { display: flex; flex-direction: column; align-items: center; padding-top: 20px; }
.back-btn { align-self: flex-start; margin-bottom: 20px; cursor: pointer; color: #888; font-size: 14px; }
.back-btn:hover { color: #fff; }
@keyframes fadeIn { from {opacity: 0; transform: translateY(10px);} to {opacity: 1; transform: translateY(0);} }
</style>